<template>
  <div class="breadcrumbs__wrapper">
    <v-breadcrumbs :items="items">
      <template slot="item" slot-scope="props">
        <router-link :to="props.item.href" :data-qe-id="`breadCrumb_${getBreadcrumbName(props.item.name)}`">
            {{getRouterLinkName(props.item.name)}}
        </router-link>
      </template>
    </v-breadcrumbs>
  </div>
</template>

<script>
    import orderBy from "lodash/orderBy";
    import { mapGetters } from "vuex";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { capitalize, routerNames } from "../appCommon.constants";
    import { myToolsConstants } from "../Tools/mytools.constant";
    import { communityCommonConstant } from "@/components/ChapterPage/communityCommon.constant";

    export default {
        name: 'Breadcrumb',
        methods: {
            getRouterLinkName(linkName) {
              return linkName && linkName.toLowerCase() === routerNames.BUSINESSES.toLowerCase()
                  ? communityCommonConstant.AROUND_ME
                  : linkName;
            },
            getPrimaryId(itemList) {
                let primaryId = "";
                if (itemList && itemList.length > 0) {
                    primaryId = itemList.find(c => c.isPrimaryCommunity);
                    primaryId = primaryId ? primaryId.communityId : itemList[0].communityId;
                }
                return primaryId;
            },
            getPrimaryName(itemList) {
                let primaryName = "";
                if (itemList && itemList.length > 0) {
                    primaryName = itemList.find(c => c.isPrimaryCommunity);
                    primaryName = primaryName ? primaryName.name : itemList[0].name;
                }
                return primaryName;
            },
            getRouteDetail(routeName, communityId) {
                let routeItems = this.getCommunityListByType(routeName);
                routeItems = orderBy(routeItems, ["name"], ["asc"]);
                communityId = !communityId ? this.getPrimaryId(routeItems) : communityId;
                return `/${routeName.toLowerCase()}/${communityId}`;
            },
            getCommunityListByType(routeName) {
                let communitiesList = [];
                if (this.usersCommunitiesList) {
                    communitiesList = this.usersCommunitiesList.filter(o => o.communityType.toLowerCase() === routeName.toLowerCase());
                }
                communitiesList = orderBy(communitiesList, ["name"], ["asc"]);
                return communitiesList;
            },
            getBreadcrumbName(breadCrumbName) {
                const removedWhiteSpaces = breadCrumbName.split(" ").join("");
                return removedWhiteSpaces;
            },
            capitalize,
        },
        computed: {
            ...mapGetters({
                usersCommunitiesList: `chapter/${storeGetters.usersCommunitiesList}`,
                communityInfo: `chapter/${storeGetters.communityInfo}`,
                ypoNetworks: `network/${storeGetters.ypoNetworks}`,
            }),
            isAllNetworks() {
                return this.usersCommunitiesList && this.usersCommunitiesList.some(o => o.communityId === this.$route.params.communityId && o.name.toLowerCase() === myToolsConstants.YOUR_NETWORKS_CONSOLIDATED_LOWER_CASE);
            },
            isSubNetwork() {
                //!checking if current item exists in YpoNetworks if not that will be a subnetwork
                return this.ypoNetworks && this.$route.name === routerNames.NETWORK && !this.ypoNetworks.some(o => o.communityId === this.$route.params.communityId);
            },
            getParentNetwork() {
                if (this.ypoNetworks && this.isSubNetwork && this.communityInfo) {
                    return this.ypoNetworks.find(o => o.communityId === this.communityInfo.parentId);
                }
            },
            isChapterWaivers() {
                return this.$route && this.$route.name.toLowerCase().includes("chapterwaiver");
            },
            isRegionalWaivers() {
                return this.$route && this.$route.name.toLowerCase().includes("regional");
            },
            routeName() {
                return this.isRegionalWaivers ? routerNames.REGION : routerNames.CHAPTER;
            },
            items() {
                const array = [];
                array.push({ name: 'Home', href: '/home', disabled: false });
                if (this.$route && this.$route.name) {
                    const level1Href = this.getRouteDetail(this.isWaiver ? this.routeName : this.$route.name);
                    array.push({ name: this.capitalize(this.isWaiver ? this.routeName : this.$route.name), href: level1Href, disabled: false });
                }
                if (this.isSubNetwork && this.getParentNetwork && !this.isAllNetworks) {
                    const level2Href = this.getRouteDetail(this.getParentNetwork.communityType, this.getParentNetwork.communityId);
                    array.push({ name: this.getParentNetwork.name, href: level2Href, disabled: false });
                }
                if (this.$route && this.$route.params.communityId) {
                    const level3Href = this.getRouteDetail(this.isWaiver ? this.routeName : this.$route.name, this.$route.params.communityId);
                    array.push({ name: this.communityInfo && this.communityInfo.name && !this.isAllNetworks ? this.communityInfo.name : "All Networks", href: level3Href, disabled: !this.isWaiver });
                }
                if (this.isWaiver) {
                    const level4Href = `${this.isChapterWaivers ? "/chapterWaiver" : "/regionalWaiver"}/${this.$route.params.communityId}`;
                    array.push({ name: this.isChapterWaivers ? "Chapter Waivers" : "Regional Waivers", href: level4Href, disabled: true });
                }
                return array;
            },
            isValidWaiver() {
                return this.$route && this.$route.params && this.$route.params.communityId;
            },
            isWaiver() {
                return this.isRegionalWaivers || this.isChapterWaivers;
            },
        },
    };
</script>

<style lang="scss">
    @import '../../common/styles/_colors.scss';
    @import '../../common/styles/_responsive.scss';

    .breadcrumbs__wrapper {
      .v-breadcrumbs {
        position: relative;
        z-index: 1;
        padding: 15px 25px;

        a {
          font-size: 12px;
          color: $white;
          text-decoration: none !important;
          font-weight: 400;

          &[href] {
            color: rgba($white, 0.9);
          }

          &.router-link-active {
            color: rgba($white, 0.5);
            cursor: default;
            pointer-events: none;
          }
        }

        &__divider {
          padding: 0 5px;
        }
      }

      @include breakpoint(xs) {
        .v-breadcrumbs {
          padding: 15px 15px 0 15px;
          top: 0 !important;
        }
      }
    }
</style>
